import { FormLayout, Spacing } from '@billy/design-system'

export const modalContentLayout: FormLayout = {
  columnSpacing: Spacing.S40,
  rowSpacing: Spacing.S16,
  spacing: Spacing.S16,
  itemsInRow: 2,
}
